import React from "react";
import { Link } from "react-router-dom";
import { Modal, Table } from "antd";
import {
  RopeDetailModalKeyClass,
  RopeDetailModalKeyWidth,
  RopeDetailModalWidth,
  RopeLandingPageData
} from "types/Rope";
import formatDate from "../../utils/formatDate";

type RopeDetailsModalProps = {
  modalState: boolean;
  closeModal: () => void;
  record: RopeLandingPageData | null;
};

const RopeDetailsModal = (props: RopeDetailsModalProps) => {
  const columns = [
    {
      title: "Detail",
      key: "k",
      className: RopeDetailModalKeyClass,
      dataIndex: "k",
      width: RopeDetailModalKeyWidth
    },
    {
      title: "Text",
      key: "v",
      render: (text, record: any) => {
        if (record.k === "Uploaded By" && record.v) {
          return props.record?.uploadedById ? (
            <Link to={`/employees/${props.record.uploadedById}`}>{record.v}</Link>
          ) : (
            record.v
          );
        }

        if (typeof record.v === "object" && "projectCode" in record.v) {
          if (record.v.referenceId) {
            return (
              <a
                href={`https://app.projectorpsa.com/x/ProjectLanding/${
                  record.v.referenceId
                }`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={event => event.stopPropagation()}
              >
                {record.v.projectCode}
              </a>
            );
          } else {
            return record.v.projectCode;
          }
        } else {
          return record.v;
        }
      }
    }
  ];

  let data = [{}];

  if (props.record) {
    data = [
      {
        k: "ROPE ID",
        v: props.record.id
      },
      { k: "Status", v: props.record.status },
      { k: "Project Code", v: props.record },
      { k: "Project Name", v: props.record.projectName },
      { k: "Reference ID", v: props.record.referenceId },
      { k: "Client Name", v: props.record.clientName },
      { k: "Office", v: props.record.office },
      { k: "Start Date", v: formatDate(props.record.startDate) },
      { k: "Flags", v: props.record.flags.join(", ") },
      { k: "Inactive", v: props.record.inactive ? "Yes" : "No" },
      { k: "Upload ID", v: props.record.uploadId },
      { k: "Upload Status", v: props.record.uploadStatus },
      { k: "Upload Version", v: props.record.uploadVersion },
      { k: "Uploaded By", v: props.record.uploadedBy }
    ];
  }

  return (
    <Modal
      title={"ROPE Details"}
      visible={props.modalState}
      onCancel={props.closeModal}
      footer={null}
      width={RopeDetailModalWidth}
    >
      <Table
        pagination={false}
        showHeader={false}
        columns={columns}
        dataSource={data}
        rowKey="k"
      />
    </Modal>
  );
};

export default RopeDetailsModal;
